function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "z245nyqvsa"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.859 13.6a1.46 1.46 0 0 0 1.632 1.647h4.7A1.459 1.459 0 0 0 12.82 13.6v-.93h.854a1.46 1.46 0 0 0 1.632-1.647v-6.9a1.46 1.46 0 0 0-1.632-1.647h-4.7A1.46 1.46 0 0 0 7.34 4.122v.924h-.848a1.462 1.462 0 0 0-1.633 1.647zm5.278-9.331a.313.313 0 0 1-.337-.318v-.115a.318.318 0 0 1 .342-.316h2.376a.318.318 0 0 1 .342.316v.116a.316.316 0 0 1-.342.316zm-4.293 9.27V6.754a.649.649 0 0 1 .728-.723h1.542v2.752a.944.944 0 0 0 1.07 1.07h2.652v3.686a.647.647 0 0 1-.728.723H6.572a.647.647 0 0 1-.728-.723zm3.435-4.555c-.206 0-.3-.09-.3-.3V6.221L11.7 8.984z",
  transform: "translate(-2.083 -1.061)"
});

function SvgCopyText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#z245nyqvsa)"
    }
  }, _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyText);
export default __webpack_public_path__ + "static/media/copy_text.5101ec10.svg";
export { ForwardRef as ReactComponent };